var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem6B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m667.94 147.91v-29.875h-587.62v29.875h587.62z",
    fill: "#bfbfbf",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m668.8 148.65v-31.727h-589.6v31.727h589.6m-1.7283-29.628v27.9h-585.77v-27.9h585.77zm-81.724 128.88v-76.663h-5.6787v76.663h5.6787z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.66 180.75c-7.6539-9.6292-13.826-20.616-18.271-32.838-4.3208 12.222-10.37 23.209-18.271 32.838l18.271-6.6663 18.271 6.6663zm-142.46 67.157v-76.663h-5.6787v76.663h5.6787z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.5 180.75c-7.6539-9.6292-13.826-20.616-18.271-32.838-4.3208 12.222-10.37 23.209-18.271 32.838l18.271-6.6663 18.271 6.6663zm-104.81 67.157v-76.663h-5.6787v76.663h5.6787z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.25 180.75c-7.7774-9.6292-13.826-20.616-18.271-32.838-4.4442 12.222-10.617 23.209-18.271 32.838l18.271-6.6663 18.271 6.6663zm-98.884 67.157v-76.663h-5.6787v76.663h5.6787z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.92 180.75c-7.7774-9.6292-13.826-20.616-18.271-32.838-4.4442 12.222-10.617 23.209-18.271 32.838l18.271-6.6663 18.271 6.6663z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2346 0 0 1.2344 -75.573 -42.722)",
    x: 544.913,
    y: 54.50719,
    fontFamily: "'ArialMT'",
    fontSize: "16.646px",
    stroke: "null"
  }, "20kg"), /*#__PURE__*/React.createElement("path", {
    d: "m634.11 43.967c-0.86415-8.8884-5.6787-13.58-14.567-14.444-8.8884 0.7407-13.58 5.5553-14.444 14.444 0.7407 8.8884 5.5553 13.703 14.444 14.567 8.8884-0.86415 13.703-5.8022 14.567-14.567m-5.9256 0c-0.4938 5.1849-3.4566 8.0243-8.6415 8.3946-5.0615-0.4938-7.9008-3.3332-8.3946-8.3946 0.4938-5.0615 3.3332-7.9008 8.3946-8.3946 5.3084 0.37035 8.1477 3.2097 8.6415 8.3946z",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m619.42 28.412c-9.3822 0.86415-14.567 6.0491-15.555 15.555 0.86415 9.6292 6.0491 14.814 15.555 15.802 9.6292-0.86415 14.814-6.1725 15.802-15.802-0.86415-9.5057-6.1725-14.691-15.802-15.555m13.456 15.555c-0.12345 3.7035-1.4814 6.9132-3.827 9.6292-2.7159 2.469-5.8022 3.7035-9.6292 3.827-3.7035-0.12345-6.7898-1.4814-9.3822-3.827-2.5925-2.7159-3.827-5.8022-3.827-9.6292s1.2345-6.9132 3.827-9.3822c2.5925-2.5925 5.6787-3.827 9.3822-3.827s6.9132 1.2345 9.6292 3.827c2.469 2.469 3.7035 5.5553 3.827 9.3822m-22.962 0c0.4938 5.8022 3.7035 9.0119 9.6292 9.6292 6.0491-0.61725 9.2588-3.827 9.876-9.6292-0.4938-5.8022-3.827-9.0119-9.876-9.6292-5.9256 0.4938-9.1353 3.7035-9.6292 9.6292m4.3208 5.1849c-1.2345-1.4814-1.9752-3.2097-2.0987-5.3084 0.12345-2.0987 0.7407-3.827 2.0987-5.3084 1.358-1.358 3.0863-2.0987 5.3084-2.0987 4.5677 0.37035 7.0367 2.8394 7.5305 7.2836-0.12345 2.0987-0.86415 3.827-2.2221 5.3084-1.358 1.358-3.0863 2.0987-5.3084 2.0987-2.2221 0.12345-3.9504-0.61725-5.3084-1.9752z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m661.15 117.91-17.16-73.7h-49.38l-16.913 73.7h83.453z",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m593.99 42.979v0.86415l-17.407 75.181h86.045l-17.53-76.046h-51.109m65.799 73.823h-80.366l16.295-71.478h47.528l16.542 71.478z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.56 81.002c-0.4938-4.3208-2.8394-6.7898-7.0367-7.2836-4.4442 0.4938-6.9132 2.8394-7.2836 7.2836 0.37035 4.4442 2.8394 6.9132 7.2836 7.2836 4.1973-0.37035 6.5429-2.8394 7.0367-7.2836m-2.9628 0c-0.2469 2.7159-1.6049 4.0739-4.0739 4.3208-2.7159-0.2469-4.1973-1.7283-4.3208-4.3208 0.12345-2.469 1.6049-3.827 4.3208-4.0739 2.469 0.12345 3.827 1.4814 4.0739 4.0739z",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.76 256.67c-2.9628-2.9628-6.4194-4.4442-10.617-4.4442s-7.7774 1.4814-10.74 4.4442-4.4442 6.5429-4.4442 10.74 1.4814 7.7774 4.4442 10.74 6.5429 4.4442 10.74 4.4442 7.6539-1.4814 10.617-4.4442 4.4442-6.5429 4.4442-10.74-1.4814-7.7774-4.4442-10.74z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2322 0 0 1.2345 278.35 273.48)",
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null"
  }, "4"), /*#__PURE__*/React.createElement("path", {
    d: "m376.59 256.67c-2.9628-2.9628-6.4194-4.4442-10.617-4.4442s-7.7774 1.4814-10.74 4.4442-4.4442 6.5429-4.4442 10.74 1.4814 7.7774 4.4442 10.74 6.5429 4.4442 10.74 4.4442 7.6539-1.4814 10.617-4.4442 4.4442-6.5429 4.4442-10.74-1.4814-7.7774-4.4442-10.74z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2322 0 0 1.2345 361.18 273.48)",
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null"
  }, "3"), /*#__PURE__*/React.createElement("path", {
    d: "m465.97 256.67c-2.9628-2.9628-6.4194-4.4442-10.617-4.4442s-7.7774 1.4814-10.74 4.4442-4.4442 6.5429-4.4442 10.74 1.4814 7.7774 4.4442 10.74 6.5429 4.4442 10.74 4.4442 7.6539-1.4814 10.617-4.4442 4.4442-6.5429 4.4442-10.74-1.4814-7.7774-4.4442-10.74z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2322 0 0 1.2345 450.5 273.48)",
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null"
  }, "2"), /*#__PURE__*/React.createElement("path", {
    d: "m594.24 256.67c-2.9628-2.9628-6.4194-4.4442-10.617-4.4442s-7.7774 1.4814-10.74 4.4442-4.4442 6.5429-4.4442 10.74 1.4814 7.7774 4.4442 10.74 6.5429 4.4442 10.74 4.4442 7.6539-1.4814 10.617-4.4442 4.4442-6.5429 4.4442-10.74-1.4814-7.7774-4.4442-10.74z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2322 0 0 1.2345 578.83 273.48)",
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2346 0 0 1.2345 179.84 76.617)",
    x: -56.9943,
    y: -42,
    fontFamily: "'ArialMT'",
    fontSize: "16.646px",
    stroke: "null"
  }, "20kg"), /*#__PURE__*/React.createElement("path", {
    d: "m149.79 44.02c-0.86415-8.8884-5.6787-13.58-14.567-14.444-8.8884 0.7407-13.58 5.5553-14.444 14.444 0.7407 8.8884 5.5553 13.703 14.444 14.567 8.8884-0.86415 13.703-5.8022 14.567-14.567m-5.9256 0c-0.4938 5.1849-3.4566 8.0243-8.6415 8.3946-5.0615-0.4938-7.9008-3.3332-8.3946-8.3946 0.4938-5.0615 3.3332-7.9008 8.3946-8.3946 5.3084 0.37035 8.1477 3.2097 8.6415 8.3946z",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.1 28.465c-9.3822 0.86415-14.567 6.0491-15.555 15.555 0.86415 9.6292 6.0491 14.814 15.555 15.802 9.6292-0.86415 14.814-6.1725 15.802-15.802-0.86415-9.5057-6.1725-14.691-15.802-15.555m13.456 15.555c-0.12345 3.7035-1.4814 6.9132-3.827 9.6292-2.7159 2.469-5.8022 3.7035-9.6292 3.827-3.7035-0.12345-6.7898-1.4814-9.3822-3.827-2.5925-2.7159-3.827-5.8022-3.827-9.6292s1.2345-6.9132 3.827-9.3822c2.5925-2.5925 5.6787-3.827 9.3822-3.827s6.9132 1.2345 9.6292 3.827c2.469 2.469 3.7035 5.5553 3.827 9.3822m-22.962 0c0.4938 5.8022 3.7035 9.0119 9.6292 9.6292 6.0491-0.61725 9.2588-3.827 9.876-9.6292-0.4938-5.8022-3.827-9.0119-9.876-9.6292-5.9256 0.4938-9.1353 3.7035-9.6292 9.6292m4.3208 5.1849c-1.2345-1.4814-1.9752-3.2097-2.0987-5.3084 0.12345-2.0987 0.7407-3.827 2.0987-5.3084 1.358-1.358 3.0863-2.0987 5.3084-2.0987 4.5677 0.37035 7.0367 2.8394 7.5305 7.2836-0.12345 2.0987-0.86415 3.827-2.2221 5.3084-1.358 1.358-3.0863 2.0987-5.3084 2.0987-2.2221 0.12345-3.9504-0.61725-5.3084-1.9752z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.83 117.97-17.16-73.7h-49.38l-16.913 73.7h83.453z",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.67 43.033v0.86415l-17.407 75.181h86.045l-17.53-76.046h-51.109m65.799 73.823h-80.366l16.295-71.478h47.528l16.542 71.478z",
    stroke: "null"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem6B);
export default __webpack_public_path__ + "static/media/item6b.163e2031c81a1c4007627c5160ade6b2.svg";
export { ForwardRef as ReactComponent };